// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbWrapper":"Breadcrumb_breadcrumbWrapper__67SxI","wrapper":"Breadcrumb_wrapper__DWzVj","overlay":"Breadcrumb_overlay__eQtrz"};